export const defaultMessage = '連線好像出了點問題，請過一段時間再試試看。如果問題持續發生，歡迎寄信至 fin@teach4taiwan.org 詢問。';

export default {
  defaultMessage,
};
